import Link from "next/link";
import type { ServiceOffering } from "@/types/services";
import { ServiceCtas } from "@/components/services/ServiceCtas";

export function ServiceOfferingCard({ offering }: { offering: ServiceOffering }) {
  const hasDetails = Boolean(offering.body);

  return (
    <article className="rounded-[var(--border-radius)] border border-[var(--color-border)] bg-[var(--color-surface)] p-5 shadow-sm">
      <div className="flex flex-col gap-4 md:flex-row">
        {offering.imageUrl ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            src={offering.imageUrl}
            alt=""
            className="h-36 w-full rounded-[var(--border-radius)] object-cover md:h-28 md:w-40"
          />
        ) : null}
        <div className="min-w-0 flex-1">
          <h3 className="text-xl font-semibold text-[var(--color-text)]" style={{ fontFamily: "var(--font-heading)" }}>
            {offering.name}
          </h3>
          {(offering.priceLabel || offering.durationLabel) && (
            <p className="mt-1 text-sm text-[var(--color-secondary)]">
              {[offering.durationLabel, offering.priceLabel].filter(Boolean).join(" · ")}
            </p>
          )}
          {offering.excerpt ? (
            <p className="mt-2 text-[var(--color-text)]">{offering.excerpt}</p>
          ) : null}
          {hasDetails ? (
            <details className="mt-3">
              <summary className="cursor-pointer text-sm font-medium text-[var(--color-primary)] hover:underline">
                Click for more details
              </summary>
              <div
                className="prose mt-3 max-w-none text-sm text-[var(--color-text)]"
                dangerouslySetInnerHTML={{ __html: offering.body || "" }}
              />
            </details>
          ) : null}
          <div className="mt-4 flex flex-wrap items-center gap-4">
            <Link
              href={`/services/${offering.slug}`}
              className="text-sm font-medium text-[var(--color-primary)] hover:underline"
            >
              Full details
            </Link>
            <ServiceCtas offering={offering} />
          </div>
        </div>
      </div>
    </article>
  );
}
